// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__gbvDd","logo":"NavBar_logo__qYFi-","link":"NavBar_link__BNeEO","active":"NavBar_active__SUoA6"};